import styled from '@emotion/styled';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';

const Title = styled(H3)`
  font-weight: ${Fonts.HEAVY};
`;
const DescriptionWrapper = styled.div`
  padding: ${Spacings.SPACING_6B};
  background: var(--color-base-1);
  box-shadow: ${boxShadowGenerator()};
  margin-top: ${Spacings.SPACING_6B};
  border-radius: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_4B};
    padding: ${Spacings.SPACING_4B};
  }
`;
const Description = styled(P1)``;

const AboutCourse = ({ description }) => {
  if (!description) return null;
  return (
    <>
      <Title>About this course</Title>
      <DescriptionWrapper>
        <Description>{description}</Description>
      </DescriptionWrapper>
    </>
  );
};
export default AboutCourse;
